import cn from 'classnames'
import { Route, Switch } from 'react-router-dom'

import style
  from '@src/pages/PaymentMethods/PaymentMethods.module.scss'
import { IndividualsPanel } from '@src/components/IndividualsPanel/IndividualsPanel'
import { Footer } from '@src/components/Footer/Footer'
import { TabList } from '@src/components/Tablist/TabList'
import { Erip } from '@src/pages/PaymentMethods/methods/Erip'
import { Mobile } from '@src/pages/PaymentMethods/methods/Mobile'
import { Cards } from '@src/pages/PaymentMethods/methods/Cards'
import { Cash } from '@src/pages/PaymentMethods/methods/Cash'
import { Ecash } from '@src/pages/PaymentMethods/methods/Ecash'
import { ReturnBtn } from '@src/components/Button/ReturnBtn'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '@src/store/store'
import { useEffect } from 'react'
import { setPageTitle } from '@src/store/ducks/app/reducer'

const tabListOptions:Array<{ url: string, title: string }> = [
  {
    url: '/payment-methods/erip',
    title: 'ЕРИП (Расчет)',
  },
  {
    url: 'http://cosmos-telecom.by:8080/?pt=3',
    title: 'Онлайн на сайте',
  },
  {
    url: '/payment-methods/mobile',
    title: 'Мобильный телефон',
  },
  {
    url: '/payment-methods/cards',
    title: 'Банкомат / Касса',
  },
  {
    url: '/payment-methods/cash',
    title: 'Наличный расчет',
  },
  {
    url: '/payment-methods/ecash',
    title: 'Электронные деньги',
  },
]

export const PaymentMethods = () => {
  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => { dispatch(setPageTitle('Способы оплаты')) }, [dispatch])

  return (
    <div>
      <IndividualsPanel />
      <div className={cn(style.tariffContainer, 'container')}>
        <ReturnBtn type="secondary">Вернуться</ReturnBtn>
        <h2 className={style.mainTitle}>Способы оплаты</h2>
        <div className={style.paymentMethodsContainer}>
          <div className={style.pay_nav_items}>
            <TabList options={tabListOptions} className={style.navSize} />
          </div>
          <div className={style.itemDescription}>
            <Switch>
              <Route path="/payment-methods/erip" component={Erip} />
              <Route path="/payment-methods/mobile" component={Mobile} />
              <Route path="/payment-methods/cards" component={Cards} />
              <Route path="/payment-methods/cash" component={Cash} />
              <Route path="/payment-methods/ecash" component={Ecash} />
            </Switch>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}
